var _path, _path2, _path3, _path4, _path5, _path6, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _path7, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _path8, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _path9, _rect66, _rect67, _rect68, _rect69, _rect70, _rect71, _rect72, _rect73, _rect74, _rect75, _rect76, _rect77, _rect78, _rect79, _rect80, _rect81, _rect82, _rect83, _rect84, _rect85, _rect86, _rect87, _rect88, _rect89, _rect90, _rect91, _rect92, _rect93, _rect94, _rect95, _rect96, _rect97, _rect98, _rect99, _rect100, _rect101, _rect102, _rect103, _rect104, _rect105, _rect106, _rect107, _rect108, _rect109, _rect110, _rect111, _rect112, _rect113, _rect114, _path10, _rect115, _rect116, _rect117, _rect118, _rect119, _rect120, _rect121, _path11, _rect122, _rect123, _rect124, _rect125, _path12, _path13, _rect126, _rect127, _rect128, _rect129, _rect130, _rect131, _rect132, _rect133, _rect134, _rect135, _rect136, _rect137, _rect138, _rect139, _rect140, _rect141, _rect142, _rect143, _rect144, _rect145, _rect146, _rect147, _rect148, _rect149, _rect150, _rect151, _rect152, _rect153, _path14, _path15, _path16, _rect154, _rect155, _rect156, _path17, _rect157, _rect158, _path18, _path19, _path20, _rect159, _rect160, _rect161, _rect162, _rect163, _rect164, _rect165, _rect166, _rect167, _rect168, _rect169, _rect170, _rect171, _rect172, _rect173, _rect174, _rect175, _rect176, _rect177, _rect178, _path21, _path22, _path23, _path24, _path25;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQDlogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 355,
    height: 41,
    viewBox: "0 0 355 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.2261 31.6099L93.2129 29.7235H94.9051V33.5518H83.2816L83.2261 31.6099ZM83.2538 33.8292C81.7003 33.8292 80.2948 33.598 79.0372 33.1356C77.7981 32.6733 76.7254 32.0075 75.8192 31.1383C74.913 30.2506 74.2195 29.1594 73.7386 27.8648C73.2578 26.5702 73.0173 25.0907 73.0173 23.4262C73.0173 21.7618 73.2578 20.2915 73.7386 19.0154C74.2195 17.7208 74.913 16.6389 75.8192 15.7697C76.7254 14.882 77.7981 14.2069 79.0372 13.7446C80.2948 13.2822 81.7003 13.051 83.2538 13.051C84.7888 13.051 86.1851 13.2822 87.4427 13.7446C88.7003 14.2069 89.7822 14.882 90.6885 15.7697C91.5947 16.6574 92.2882 17.7393 92.769 19.0154C93.2499 20.2915 93.4903 21.7618 93.4903 23.4262C93.4903 25.0907 93.2499 26.5702 92.769 27.8648C92.2882 29.1594 91.5947 30.2506 90.6885 31.1383C89.7822 32.0075 88.7003 32.6733 87.4427 33.1356C86.1851 33.598 84.7888 33.8292 83.2538 33.8292ZM83.2538 29.5848C84.2895 29.5848 85.1957 29.3628 85.9725 28.919C86.7492 28.4751 87.341 27.8001 87.7479 26.8939C88.1733 25.9877 88.3859 24.8318 88.3859 23.4262C88.3859 22.3721 88.2657 21.4659 88.0253 20.7076C87.7849 19.9309 87.4335 19.2928 86.9711 18.7935C86.5273 18.2941 85.991 17.9242 85.3622 17.6838C84.7334 17.4249 84.0306 17.2954 83.2538 17.2954C82.2182 17.2954 81.3119 17.5174 80.5352 17.9612C79.7769 18.3866 79.1851 19.0524 78.7598 19.9586C78.3344 20.8648 78.1217 22.0207 78.1217 23.4262C78.1217 24.4804 78.2419 25.4051 78.4823 26.2004C78.7413 26.9771 79.0927 27.6152 79.5365 28.1145C79.9804 28.6138 80.5167 28.9837 81.1455 29.2241C81.7743 29.4646 82.4771 29.5848 83.2538 29.5848ZM101.945 33.8292C100.78 33.8292 99.7998 33.6072 99.0045 33.1634C98.2093 32.701 97.6082 32.0352 97.2013 31.166C96.813 30.2783 96.6188 29.2149 96.6188 27.9758V18.5715H101.307V26.6997C101.307 27.421 101.39 28.0313 101.557 28.5306C101.742 29.0115 102.019 29.3813 102.389 29.6403C102.759 29.8992 103.24 30.0286 103.831 30.0286C104.442 30.0286 104.96 29.8807 105.385 29.5848C105.81 29.2889 106.134 28.9097 106.356 28.4474C106.578 27.985 106.689 27.4857 106.689 26.9494V18.5715H111.377V33.5518H106.855L106.689 30.9441H106.467C106.115 31.8873 105.533 32.6086 104.719 33.1079C103.905 33.5887 102.981 33.8292 101.945 33.8292ZM119.662 33.8292C118.756 33.8292 117.923 33.6535 117.165 33.3021C116.425 32.9507 115.787 32.4421 115.251 31.7763C114.715 31.1105 114.299 30.2968 114.003 29.3351C113.725 28.3734 113.587 27.2823 113.587 26.0616C113.587 24.4157 113.836 23.0194 114.336 21.8727C114.853 20.7076 115.565 19.8199 116.472 19.2096C117.378 18.5993 118.441 18.2941 119.662 18.2941C120.365 18.2941 121.012 18.4051 121.604 18.627C122.214 18.8305 122.732 19.1356 123.157 19.5425C123.583 19.9309 123.897 20.3932 124.101 20.9295H124.35L124.517 18.5715H128.983V33.5518H124.517L124.35 31.1938H124.101C123.805 31.989 123.25 32.6271 122.436 33.1079C121.641 33.5887 120.716 33.8292 119.662 33.8292ZM121.382 30.0564C122.048 30.0564 122.593 29.9177 123.019 29.6403C123.444 29.3443 123.758 28.9467 123.962 28.4474C124.184 27.948 124.295 27.384 124.295 26.7552V25.3681C124.295 24.7023 124.174 24.1198 123.934 23.6204C123.712 23.1211 123.388 22.742 122.963 22.483C122.556 22.2056 122.066 22.0669 121.493 22.0669C120.772 22.0669 120.18 22.2334 119.717 22.5663C119.255 22.8807 118.913 23.343 118.691 23.9533C118.469 24.5451 118.358 25.2479 118.358 26.0616C118.358 26.8569 118.46 27.5597 118.663 28.17C118.885 28.7618 119.218 29.2241 119.662 29.557C120.106 29.8899 120.679 30.0564 121.382 30.0564ZM131.911 33.5518V18.5715H136.432L136.599 21.1515H136.821C137.209 20.1898 137.81 19.4777 138.624 19.0154C139.456 18.5345 140.381 18.2941 141.398 18.2941C142.138 18.2941 142.822 18.4051 143.451 18.627C144.098 18.8489 144.662 19.2096 145.143 19.7089C145.624 20.1898 145.994 20.8278 146.253 21.6231C146.53 22.3998 146.669 23.343 146.669 24.4527V33.5518H141.981V25.4791C141.981 24.7208 141.888 24.092 141.703 23.5927C141.537 23.0933 141.269 22.7235 140.899 22.483C140.547 22.2241 140.076 22.0947 139.484 22.0947C138.855 22.0947 138.328 22.2426 137.903 22.5385C137.477 22.8344 137.154 23.2136 136.932 23.6759C136.71 24.1383 136.599 24.6284 136.599 25.1462V33.5518H131.911ZM154.734 33.5518C153.365 33.5518 152.357 33.2374 151.71 32.6086C151.081 31.9613 150.767 30.9441 150.767 29.557V22.3443H148.187V18.5715H150.767V14.6046L155.455 14.1884V18.5715H158.312V22.3443H155.455V28.6693C155.455 29.0947 155.557 29.3906 155.76 29.557C155.982 29.705 156.269 29.779 156.62 29.779H158.34V33.5518H154.734ZM165.718 33.8292C164.553 33.8292 163.573 33.6072 162.778 33.1634C161.982 32.701 161.381 32.0352 160.975 31.166C160.586 30.2783 160.392 29.2149 160.392 27.9758V18.5715H165.08V26.6997C165.08 27.421 165.163 28.0313 165.33 28.5306C165.515 29.0115 165.792 29.3813 166.162 29.6403C166.532 29.8992 167.013 30.0286 167.605 30.0286C168.215 30.0286 168.733 29.8807 169.158 29.5848C169.584 29.2889 169.907 28.9097 170.129 28.4474C170.351 27.985 170.462 27.4857 170.462 26.9494V18.5715H175.15V33.5518H170.628L170.462 30.9441H170.24C169.889 31.8873 169.306 32.6086 168.492 33.1079C167.679 33.5887 166.754 33.8292 165.718 33.8292ZM178.081 33.5518V18.5715H182.631L182.769 21.1515H182.991C183.343 20.1898 183.916 19.4777 184.711 19.0154C185.525 18.5345 186.413 18.2941 187.374 18.2941C188.392 18.2941 189.326 18.5345 190.176 19.0154C191.027 19.4962 191.656 20.3377 192.063 21.5398H192.285C192.617 20.4487 193.219 19.6349 194.088 19.0986C194.975 18.5623 195.974 18.2941 197.084 18.2941C198.045 18.2941 198.905 18.4976 199.664 18.9044C200.422 19.2928 201.023 19.9401 201.467 20.8463C201.929 21.7525 202.16 22.9546 202.16 24.4527V33.5518H197.472V25.4791C197.472 24.7208 197.389 24.092 197.222 23.5927C197.075 23.0933 196.825 22.7235 196.473 22.483C196.141 22.2241 195.697 22.0947 195.142 22.0947C194.569 22.0947 194.078 22.2426 193.672 22.5385C193.283 22.8344 192.987 23.2136 192.784 23.6759C192.58 24.1383 192.479 24.6284 192.479 25.1462V33.5518H187.763V25.4791C187.763 24.7208 187.689 24.092 187.541 23.5927C187.393 23.0933 187.143 22.7235 186.792 22.483C186.459 22.2241 186.015 22.0947 185.46 22.0947C184.887 22.0947 184.397 22.2426 183.99 22.5385C183.602 22.8344 183.296 23.2136 183.075 23.6759C182.871 24.1383 182.769 24.6284 182.769 25.1462V33.5518H178.081Z",
    fill: "#111111"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M205.007 33.5518V13.3285H213.856C215.891 13.3285 217.601 13.7538 218.988 14.6046C220.394 15.4553 221.457 16.6389 222.179 18.1554C222.9 19.6719 223.261 21.4381 223.261 23.454C223.261 24.952 223.057 26.3206 222.65 27.5597C222.243 28.7988 221.633 29.8714 220.819 30.7776C220.024 31.6654 219.044 32.3496 217.879 32.8305C216.732 33.3113 215.391 33.5518 213.856 33.5518H205.007ZM209.973 29.3351H213.024C213.745 29.3351 214.411 29.2519 215.021 29.0854C215.65 28.9005 216.196 28.5861 216.658 28.1422C217.139 27.6984 217.509 27.0881 217.768 26.3113C218.045 25.5346 218.184 24.5451 218.184 23.343C218.184 21.8265 217.953 20.6521 217.49 19.8199C217.047 18.9692 216.436 18.3773 215.66 18.0445C214.901 17.7116 214.023 17.5451 213.024 17.5451H209.973V29.3351ZM231.292 33.8292C230.386 33.8292 229.553 33.6535 228.795 33.3021C228.055 32.9507 227.417 32.4421 226.881 31.7763C226.345 31.1105 225.929 30.2968 225.633 29.3351C225.355 28.3734 225.217 27.2823 225.217 26.0616C225.217 24.4157 225.466 23.0194 225.966 21.8727C226.483 20.7076 227.195 19.8199 228.102 19.2096C229.008 18.5993 230.071 18.2941 231.292 18.2941C231.995 18.2941 232.642 18.4051 233.234 18.627C233.844 18.8305 234.362 19.1356 234.787 19.5425C235.213 19.9309 235.527 20.3932 235.73 20.9295H235.98L236.147 18.5715H240.613V33.5518H236.147L235.98 31.1938H235.73C235.435 31.989 234.88 32.6271 234.066 33.1079C233.271 33.5887 232.346 33.8292 231.292 33.8292ZM233.012 30.0564C233.678 30.0564 234.223 29.9177 234.649 29.6403C235.074 29.3443 235.388 28.9467 235.592 28.4474C235.814 27.948 235.925 27.384 235.925 26.7552V25.3681C235.925 24.7023 235.804 24.1198 235.564 23.6204C235.342 23.1211 235.018 22.742 234.593 22.483C234.186 22.2056 233.696 22.0669 233.123 22.0669C232.402 22.0669 231.81 22.2334 231.347 22.5663C230.885 22.8807 230.543 23.343 230.321 23.9533C230.099 24.5451 229.988 25.2479 229.988 26.0616C229.988 26.8569 230.09 27.5597 230.293 28.17C230.515 28.7618 230.848 29.2241 231.292 29.557C231.736 29.8899 232.309 30.0564 233.012 30.0564ZM248.978 33.5518C247.609 33.5518 246.601 33.2374 245.954 32.6086C245.325 31.9613 245.011 30.9441 245.011 29.557V22.3443H242.431V18.5715H245.011V14.6046L249.699 14.1884V18.5715H252.556V22.3443H249.699V28.6693C249.699 29.0947 249.801 29.3906 250.004 29.557C250.226 29.705 250.513 29.779 250.864 29.779H252.584V33.5518H248.978ZM260.158 33.8292C259.252 33.8292 258.419 33.6535 257.661 33.3021C256.921 32.9507 256.283 32.4421 255.747 31.7763C255.211 31.1105 254.795 30.2968 254.499 29.3351C254.221 28.3734 254.083 27.2823 254.083 26.0616C254.083 24.4157 254.332 23.0194 254.832 21.8727C255.349 20.7076 256.061 19.8199 256.968 19.2096C257.874 18.5993 258.937 18.2941 260.158 18.2941C260.861 18.2941 261.508 18.4051 262.1 18.627C262.71 18.8305 263.228 19.1356 263.653 19.5425C264.079 19.9309 264.393 20.3932 264.596 20.9295H264.846L265.013 18.5715H269.479V33.5518H265.013L264.846 31.1938H264.596C264.301 31.989 263.746 32.6271 262.932 33.1079C262.137 33.5887 261.212 33.8292 260.158 33.8292ZM261.878 30.0564C262.544 30.0564 263.089 29.9177 263.515 29.6403C263.94 29.3443 264.254 28.9467 264.458 28.4474C264.68 27.948 264.791 27.384 264.791 26.7552V25.3681C264.791 24.7023 264.67 24.1198 264.43 23.6204C264.208 23.1211 263.884 22.742 263.459 22.483C263.052 22.2056 262.562 22.0669 261.989 22.0669C261.267 22.0669 260.676 22.2334 260.213 22.5663C259.751 22.8807 259.409 23.343 259.187 23.9533C258.965 24.5451 258.854 25.2479 258.854 26.0616C258.854 26.8569 258.956 27.5597 259.159 28.17C259.381 28.7618 259.714 29.2241 260.158 29.557C260.602 29.8899 261.175 30.0564 261.878 30.0564ZM272.573 33.5518V13.3285H277.539V29.8899L276.873 29.1409H286.249V33.5518H272.573ZM287.275 38.1845V34.3563H289.106C289.494 34.3563 289.827 34.3008 290.104 34.1898C290.382 34.0973 290.613 33.9401 290.798 33.7182C291.001 33.5148 291.168 33.2466 291.297 32.9137L291.908 31.3047V33.2743L285.832 18.5715H290.992L293.211 26.0062L293.766 28.0313H293.933L294.432 26.0062L296.513 18.5715H301.562L295.93 33.9401C295.523 35.0683 295.024 35.9375 294.432 36.5478C293.859 37.1766 293.202 37.602 292.462 37.8239C291.723 38.0643 290.9 38.1845 289.993 38.1845H287.275ZM309.233 33.5518C308.142 33.5518 307.291 33.3946 306.681 33.0802C306.089 32.7473 305.673 32.2849 305.433 31.6931C305.211 31.1013 305.1 30.4078 305.1 29.6125V22.3443H302.52V18.5715H305.1V14.6046L309.788 14.1884V18.5715H319.691V33.5518H315.003V22.3443H309.788V28.7525C309.788 29.1594 309.89 29.4368 310.093 29.5848C310.296 29.7142 310.574 29.779 310.925 29.779H312.645V33.5518H309.233ZM317.361 17.0735C316.658 17.0735 316.076 16.8886 315.614 16.5187C315.151 16.1488 314.92 15.631 314.92 14.9652C314.92 14.2994 315.151 13.7908 315.614 13.4394C316.076 13.0695 316.658 12.8846 317.361 12.8846C318.082 12.8846 318.665 13.0695 319.109 13.4394C319.571 13.7908 319.802 14.2994 319.802 14.9652C319.802 15.631 319.571 16.1488 319.109 16.5187C318.665 16.8886 318.082 17.0735 317.361 17.0735ZM329.409 33.8292C328.262 33.8292 327.227 33.6442 326.302 33.2743C325.377 32.9045 324.582 32.3774 323.916 31.6931C323.25 31.0088 322.742 30.1951 322.39 29.2519C322.039 28.2902 321.863 27.2175 321.863 26.0339C321.863 24.8688 322.039 23.8146 322.39 22.8714C322.76 21.9097 323.278 21.0867 323.944 20.4025C324.628 19.7182 325.442 19.2003 326.385 18.8489C327.328 18.4791 328.373 18.2941 329.52 18.2941C330.851 18.2941 332.026 18.5438 333.043 19.0431C334.06 19.524 334.865 20.199 335.456 21.0682C336.067 21.9375 336.39 22.9546 336.427 24.1198H331.85C331.776 23.6574 331.619 23.2783 331.378 22.9824C331.157 22.6865 330.879 22.4645 330.546 22.3166C330.213 22.1686 329.843 22.0947 329.437 22.0947C328.956 22.0947 328.54 22.1871 328.188 22.3721C327.837 22.557 327.541 22.8252 327.301 23.1766C327.079 23.528 326.903 23.9441 326.773 24.4249C326.662 24.9058 326.607 25.4513 326.607 26.0616C326.607 26.9679 326.727 27.7169 326.968 28.3087C327.208 28.882 327.532 29.3166 327.939 29.6125C328.364 29.8899 328.854 30.0286 329.409 30.0286C329.908 30.0286 330.334 29.9362 330.685 29.7512C331.036 29.5663 331.314 29.3259 331.517 29.0299C331.739 28.7156 331.878 28.3549 331.933 27.948H336.455C336.418 29.1317 336.085 30.1673 335.456 31.0551C334.846 31.9243 334.014 32.6086 332.96 33.1079C331.924 33.5887 330.74 33.8292 329.409 33.8292ZM343.864 33.8292C342.957 33.8292 342.125 33.6535 341.367 33.3021C340.627 32.9507 339.989 32.4421 339.453 31.7763C338.916 31.1105 338.5 30.2968 338.204 29.3351C337.927 28.3734 337.788 27.2823 337.788 26.0616C337.788 24.4157 338.038 23.0194 338.537 21.8727C339.055 20.7076 339.767 19.8199 340.673 19.2096C341.58 18.5993 342.643 18.2941 343.864 18.2941C344.566 18.2941 345.214 18.4051 345.805 18.627C346.416 18.8305 346.934 19.1356 347.359 19.5425C347.784 19.9309 348.099 20.3932 348.302 20.9295H348.552L348.718 18.5715H353.185V33.5518H348.718L348.552 31.1938H348.302C348.006 31.989 347.451 32.6271 346.638 33.1079C345.842 33.5887 344.918 33.8292 343.864 33.8292ZM345.583 30.0564C346.249 30.0564 346.795 29.9177 347.22 29.6403C347.646 29.3443 347.96 28.9467 348.163 28.4474C348.385 27.948 348.496 27.384 348.496 26.7552V25.3681C348.496 24.7023 348.376 24.1198 348.136 23.6204C347.914 23.1211 347.59 22.742 347.165 22.483C346.758 22.2056 346.268 22.0669 345.694 22.0669C344.973 22.0669 344.381 22.2334 343.919 22.5663C343.457 22.8807 343.115 23.343 342.893 23.9533C342.671 24.5451 342.56 25.2479 342.56 26.0616C342.56 26.8569 342.661 27.5597 342.865 28.17C343.087 28.7618 343.42 29.2241 343.864 29.557C344.307 29.8899 344.881 30.0564 345.583 30.0564Z",
    fill: "#2B8DC8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M62.2589 23.6215C60.7396 20.3533 57.6073 18.7882 54.027 17.5759C54.0374 17.4383 54.0447 17.3005 54.0487 17.1625C54.2331 14.2522 52.6222 11.4633 49.8559 10.0484C48.2585 9.23167 46.094 8.85399 44.3767 8.79392C44.0528 8.3306 43.7471 7.84427 43.4015 7.3982C41.216 4.57865 37.6208 2.92284 33.8251 3.12223C29.2479 3.36251 25.2997 6.23255 23.8881 10.3449C21.4477 8.85718 18.3032 8.71275 15.6914 10.0484C12.7041 11.5758 11.058 14.7097 11.5792 17.8757C6.5148 18.5428 2.6506 22.4839 2.34158 27.2974C1.96546 33.1442 6.44161 37.7013 12.6235 37.7013C14.4174 37.7065 42.5195 37.7103 44.1493 37.7154V39.9943C41.0394 39.9943 15.7131 39.8978 12.6167 39.8889C9.15915 39.8786 5.86625 38.6702 3.45638 36.3063C0.953667 33.851 -0.190953 30.5413 0.0259085 27.1651C0.358655 21.9906 4.07037 17.6443 9.18219 16.147C9.38956 12.8226 11.3969 9.75635 14.5854 8.12546C17.103 6.83838 20.0557 6.61279 22.7177 7.42185C24.9243 3.67693 29.0412 1.18266 33.6963 0.937902C38.1948 0.702088 42.6174 2.67999 45.274 6.10793C45.4231 6.29965 45.5634 6.4952 45.7002 6.69331C47.5117 6.87864 49.4235 7.33877 50.9618 8.12546C54.0846 9.72248 56.1218 12.7772 56.359 16.078C59.8159 17.4264 62.7889 19.311 64.3835 22.7434C65.0124 24.0976 65.3811 25.5489 65.4726 27.0245C65.6765 30.3125 64.7176 33.4452 62.3104 35.8819C57.4717 40.7797 50.4238 39.9943 44.0081 39.9943C44.0081 39.9943 44.0081 38.2516 44.0081 37.7154L49.8708 37.81C57.0902 37.8311 63.6448 35.0102 63.1569 27.1523C63.0817 25.9387 62.7787 24.7424 62.2589 23.6215Z",
    fill: "#111111"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4567 27.5704L34.8353 27.2002V27.9407H34.0781L34.4567 27.5704Z",
    fill: "#111111"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3496 27.3223H37.1068V27.9393H36.3496L36.3496 27.3223Z",
    fill: "#111111"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4941 27.3223L37.8727 27.6308L38.2514 27.9393H37.4941L37.4941 27.3223Z",
    fill: "#111111"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 34.0781,
    y: 30.4062,
    width: 0.757217,
    height: 0.740473,
    fill: "#111111"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 34.0781,
    y: 31.4561,
    width: 0.757217,
    height: 0.740473,
    fill: "#111111"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 34.0781,
    y: 28.248,
    width: 0.757217,
    height: 0.740473,
    fill: "#111111"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 34.0781,
    y: 32.5049,
    width: 0.757217,
    height: 0.740473,
    fill: "#111111"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 34.0781,
    y: 29.2959,
    width: 0.757217,
    height: 0.740473,
    fill: "#111111"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 34.0781,
    y: 33.5537,
    width: 0.757217,
    height: 0.740473,
    fill: "#111111"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 34.0781,
    y: 34.6006,
    width: 0.757217,
    height: 0.740473,
    fill: "#111111"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 34.0781,
    y: 35.6523,
    width: 0.757217,
    height: 0.740473,
    fill: "#111111"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 34.0781,
    y: 36.7012,
    width: 0.757217,
    height: 0.740473,
    fill: "#111111"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 36.3594,
    y: 30.4053,
    width: 0.757217,
    height: 0.740473,
    fill: "#111111"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 36.3594,
    y: 31.4561,
    width: 0.757217,
    height: 0.740473,
    fill: "#111111"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 36.3594,
    y: 28.2471,
    width: 0.757217,
    height: 0.740473,
    fill: "#111111"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 36.3594,
    y: 32.5039,
    width: 0.757217,
    height: 0.740473,
    fill: "#111111"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 36.3594,
    y: 29.2949,
    width: 0.757217,
    height: 0.740473,
    fill: "#111111"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 36.3594,
    y: 33.5547,
    width: 0.757217,
    height: 0.740473,
    fill: "#111111"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 36.3594,
    y: 34.6016,
    width: 0.757217,
    height: 0.740473,
    fill: "#111111"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 36.3594,
    y: 35.6523,
    width: 0.757217,
    height: 0.740473,
    fill: "#111111"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 36.3594,
    y: 36.7002,
    width: 0.757217,
    height: 0.740473,
    fill: "#111111"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 37.4785,
    y: 30.4053,
    width: 0.757217,
    height: 0.740473,
    fill: "#111111"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 37.4785,
    y: 31.4561,
    width: 0.757217,
    height: 0.740473,
    fill: "#111111"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 37.4785,
    y: 28.2471,
    width: 0.757217,
    height: 0.740473,
    fill: "#111111"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 37.4785,
    y: 32.5039,
    width: 0.757217,
    height: 0.740473,
    fill: "#111111"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 37.4785,
    y: 29.2949,
    width: 0.757217,
    height: 0.740473,
    fill: "#111111"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 37.4785,
    y: 33.5547,
    width: 0.757217,
    height: 0.740473,
    fill: "#111111"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 37.4785,
    y: 34.6016,
    width: 0.757217,
    height: 0.740473,
    fill: "#111111"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 37.4785,
    y: 35.6523,
    width: 0.757217,
    height: 0.740473,
    fill: "#111111"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 37.4785,
    y: 36.7002,
    width: 0.757217,
    height: 0.740473,
    fill: "#111111"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 38.623,
    y: 30.4053,
    width: 0.757217,
    height: 0.740473,
    fill: "#111111"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 39.7539,
    y: 30.4053,
    width: 0.757217,
    height: 0.740473,
    fill: "#111111"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 38.623,
    y: 31.4561,
    width: 0.757217,
    height: 0.740473,
    fill: "#111111"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 39.7539,
    y: 31.4561,
    width: 0.757217,
    height: 0.740473,
    fill: "#111111"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 38.623,
    y: 28.2471,
    width: 0.50639,
    height: 0.740473,
    fill: "#111111"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 38.623,
    y: 32.5049,
    width: 0.757217,
    height: 0.740473,
    fill: "#111111"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 39.7539,
    y: 32.5049,
    width: 0.757217,
    height: 0.740473,
    fill: "#111111"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 38.623,
    y: 29.2949,
    width: 0.757217,
    height: 0.740473,
    fill: "#111111"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 38.623,
    y: 33.5537,
    width: 0.757217,
    height: 0.740473,
    fill: "#111111"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 39.7539,
    y: 33.5547,
    width: 0.757217,
    height: 0.740473,
    fill: "#111111"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 38.623,
    y: 34.6016,
    width: 0.757217,
    height: 0.740473,
    fill: "#111111"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 39.7539,
    y: 34.6025,
    width: 0.757217,
    height: 0.740473,
    fill: "#111111"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 38.623,
    y: 35.6533,
    width: 0.757217,
    height: 0.740473,
    fill: "#111111"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 39.7539,
    y: 35.6523,
    width: 0.757217,
    height: 0.740473,
    fill: "#111111"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 38.623,
    y: 36.7002,
    width: 0.757217,
    height: 0.740473,
    fill: "#111111"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 39.7539,
    y: 36.7012,
    width: 0.757217,
    height: 0.740473,
    fill: "#111111"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 35.2227,
    y: 30.4043,
    width: 0.757217,
    height: 0.740473,
    fill: "#111111"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 35.2227,
    y: 31.4551,
    width: 0.757217,
    height: 0.740473,
    fill: "#111111"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 35.2227,
    y: 28.2441,
    width: 0.757217,
    height: 0.740473,
    fill: "#111111"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2227 27.5664H35.9799V27.9366H35.2227V27.5664Z",
    fill: "#111111"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 35.2227,
    y: 32.502,
    width: 0.757217,
    height: 0.740473,
    fill: "#111111"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 35.2227,
    y: 29.2939,
    width: 0.757217,
    height: 0.740473,
    fill: "#111111"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 35.2227,
    y: 33.5527,
    width: 0.757217,
    height: 0.740473,
    fill: "#111111"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 35.2227,
    y: 34.5996,
    width: 0.757217,
    height: 0.740473,
    fill: "#111111"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 35.2227,
    y: 35.6494,
    width: 0.757217,
    height: 0.740473,
    fill: "#111111"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 35.2227,
    y: 36.6982,
    width: 0.757217,
    height: 0.740473,
    fill: "#111111"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 42.4082,
    y: 30.5967,
    width: 0.742369,
    height: 0.725954,
    fill: "#111111"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 42.4082,
    y: 31.6221,
    width: 0.742369,
    height: 0.725954,
    fill: "#111111"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5996 28.4785H43.1544V29.2045H42.5996L42.5996 28.4785Z",
    fill: "#111111"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 42.4082,
    y: 32.6514,
    width: 0.742369,
    height: 0.725954,
    fill: "#111111"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 42.4082,
    y: 29.5068,
    width: 0.742369,
    height: 0.725954,
    fill: "#111111"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 42.4082,
    y: 33.6826,
    width: 0.742369,
    height: 0.725954,
    fill: "#111111"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 42.4082,
    y: 34.707,
    width: 0.742369,
    height: 0.725954,
    fill: "#111111"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 42.4082,
    y: 35.7393,
    width: 0.742369,
    height: 0.725954,
    fill: "#111111"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 42.4082,
    y: 36.7666,
    width: 0.742369,
    height: 0.725954,
    fill: "#111111"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 44.627,
    y: 30.6016,
    width: 0.742369,
    height: 0.725954,
    fill: "#111111"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 44.627,
    y: 31.6289,
    width: 0.742369,
    height: 0.725954,
    fill: "#111111"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 44.627,
    y: 28.4834,
    width: 0.742369,
    height: 0.725954,
    fill: "#111111"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 44.627,
    y: 27.4551,
    width: 0.742369,
    height: 0.725954,
    fill: "#111111"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 44.627,
    y: 26.4678,
    width: 0.742369,
    height: 0.725954,
    fill: "#111111"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M44.987 25.8326L45.3693 25.4805V26.2064H44.627L44.987 25.8326Z",
    fill: "#111111"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 44.627,
    y: 32.6572,
    width: 0.742369,
    height: 0.725954,
    fill: "#111111"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 44.627,
    y: 29.5107,
    width: 0.742369,
    height: 0.725954,
    fill: "#111111"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 44.627,
    y: 33.6855,
    width: 0.742369,
    height: 0.725954,
    fill: "#111111"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 44.627,
    y: 34.7129,
    width: 0.742369,
    height: 0.725954,
    fill: "#111111"
  })), _rect70 || (_rect70 = /*#__PURE__*/React.createElement("rect", {
    x: 44.627,
    y: 35.7412,
    width: 0.742369,
    height: 0.725954,
    fill: "#111111"
  })), _rect71 || (_rect71 = /*#__PURE__*/React.createElement("rect", {
    x: 44.627,
    y: 36.7715,
    width: 0.742369,
    height: 0.725954,
    fill: "#111111"
  })), _rect72 || (_rect72 = /*#__PURE__*/React.createElement("rect", {
    x: 45.7363,
    y: 30.5967,
    width: 0.742369,
    height: 0.725954,
    fill: "#111111"
  })), _rect73 || (_rect73 = /*#__PURE__*/React.createElement("rect", {
    x: 45.7363,
    y: 31.625,
    width: 0.742369,
    height: 0.725954,
    fill: "#111111"
  })), _rect74 || (_rect74 = /*#__PURE__*/React.createElement("rect", {
    x: 45.7363,
    y: 28.4775,
    width: 0.742369,
    height: 0.725954,
    fill: "#111111"
  })), _rect75 || (_rect75 = /*#__PURE__*/React.createElement("rect", {
    x: 45.7363,
    y: 27.4502,
    width: 0.742369,
    height: 0.725954,
    fill: "#111111"
  })), _rect76 || (_rect76 = /*#__PURE__*/React.createElement("rect", {
    x: 45.7363,
    y: 26.4619,
    width: 0.742369,
    height: 0.725954,
    fill: "#111111"
  })), _rect77 || (_rect77 = /*#__PURE__*/React.createElement("rect", {
    x: 45.7363,
    y: 25.4746,
    width: 0.742369,
    height: 0.725954,
    fill: "#111111"
  })), _rect78 || (_rect78 = /*#__PURE__*/React.createElement("rect", {
    x: 45.7363,
    y: 24.7344,
    width: 0.742369,
    height: 0.493649,
    fill: "#111111"
  })), _rect79 || (_rect79 = /*#__PURE__*/React.createElement("rect", {
    x: 46.8477,
    y: 28.4775,
    width: 0.742369,
    height: 0.725954,
    fill: "#111111"
  })), _rect80 || (_rect80 = /*#__PURE__*/React.createElement("rect", {
    x: 46.8477,
    y: 27.4502,
    width: 0.742369,
    height: 0.725954,
    fill: "#111111"
  })), _rect81 || (_rect81 = /*#__PURE__*/React.createElement("rect", {
    x: 46.8477,
    y: 26.4619,
    width: 0.742369,
    height: 0.725954,
    fill: "#111111"
  })), _rect82 || (_rect82 = /*#__PURE__*/React.createElement("rect", {
    x: 46.8477,
    y: 25.4736,
    width: 0.742369,
    height: 0.725954,
    fill: "#111111"
  })), _rect83 || (_rect83 = /*#__PURE__*/React.createElement("rect", {
    x: 46.8477,
    y: 24.7344,
    width: 0.742369,
    height: 0.493649,
    fill: "#111111"
  })), _rect84 || (_rect84 = /*#__PURE__*/React.createElement("rect", {
    x: 47.9492,
    y: 28.4775,
    width: 0.742369,
    height: 0.725954,
    fill: "#111111"
  })), _rect85 || (_rect85 = /*#__PURE__*/React.createElement("rect", {
    x: 47.9492,
    y: 27.4502,
    width: 0.742369,
    height: 0.725954,
    fill: "#111111"
  })), _rect86 || (_rect86 = /*#__PURE__*/React.createElement("rect", {
    x: 47.9492,
    y: 26.4619,
    width: 0.742369,
    height: 0.725954,
    fill: "#111111"
  })), _rect87 || (_rect87 = /*#__PURE__*/React.createElement("rect", {
    x: 47.9492,
    y: 25.4736,
    width: 0.742369,
    height: 0.725954,
    fill: "#111111"
  })), _rect88 || (_rect88 = /*#__PURE__*/React.createElement("rect", {
    x: 47.9492,
    y: 24.7344,
    width: 0.742369,
    height: 0.493649,
    fill: "#111111"
  })), _rect89 || (_rect89 = /*#__PURE__*/React.createElement("rect", {
    x: 45.7363,
    y: 32.6523,
    width: 0.742369,
    height: 0.725954,
    fill: "#111111"
  })), _rect90 || (_rect90 = /*#__PURE__*/React.createElement("rect", {
    x: 45.7363,
    y: 29.5068,
    width: 0.742369,
    height: 0.725954,
    fill: "#111111"
  })), _rect91 || (_rect91 = /*#__PURE__*/React.createElement("rect", {
    x: 45.7363,
    y: 33.6826,
    width: 0.742369,
    height: 0.725954,
    fill: "#111111"
  })), _rect92 || (_rect92 = /*#__PURE__*/React.createElement("rect", {
    x: 45.7363,
    y: 34.7109,
    width: 0.742369,
    height: 0.725954,
    fill: "#111111"
  })), _rect93 || (_rect93 = /*#__PURE__*/React.createElement("rect", {
    x: 45.7363,
    y: 35.7373,
    width: 0.742369,
    height: 0.725954,
    fill: "#111111"
  })), _rect94 || (_rect94 = /*#__PURE__*/React.createElement("rect", {
    x: 45.7363,
    y: 36.7666,
    width: 0.742369,
    height: 0.725954,
    fill: "#111111"
  })), _rect95 || (_rect95 = /*#__PURE__*/React.createElement("rect", {
    x: 46.8535,
    y: 30.5977,
    width: 0.742369,
    height: 0.725954,
    fill: "#111111"
  })), _rect96 || (_rect96 = /*#__PURE__*/React.createElement("rect", {
    x: 47.9648,
    y: 30.5967,
    width: 0.742369,
    height: 0.725954,
    fill: "#111111"
  })), _rect97 || (_rect97 = /*#__PURE__*/React.createElement("rect", {
    x: 46.8535,
    y: 31.6289,
    width: 0.742369,
    height: 0.725954,
    fill: "#111111"
  })), _rect98 || (_rect98 = /*#__PURE__*/React.createElement("rect", {
    x: 47.9648,
    y: 31.6289,
    width: 0.742369,
    height: 0.725954,
    fill: "#111111"
  })), _rect99 || (_rect99 = /*#__PURE__*/React.createElement("rect", {
    x: 46.8535,
    y: 32.6553,
    width: 0.742369,
    height: 0.725954,
    fill: "#111111"
  })), _rect100 || (_rect100 = /*#__PURE__*/React.createElement("rect", {
    x: 47.9648,
    y: 32.6553,
    width: 0.742369,
    height: 0.725954,
    fill: "#111111"
  })), _rect101 || (_rect101 = /*#__PURE__*/React.createElement("rect", {
    x: 46.8535,
    y: 29.5107,
    width: 0.742369,
    height: 0.725954,
    fill: "#111111"
  })), _rect102 || (_rect102 = /*#__PURE__*/React.createElement("rect", {
    x: 47.9551,
    y: 29.5107,
    width: 0.742369,
    height: 0.725954,
    fill: "#111111"
  })), _rect103 || (_rect103 = /*#__PURE__*/React.createElement("rect", {
    x: 46.8535,
    y: 33.6836,
    width: 0.742369,
    height: 0.725954,
    fill: "#111111"
  })), _rect104 || (_rect104 = /*#__PURE__*/React.createElement("rect", {
    x: 47.9648,
    y: 33.6855,
    width: 0.742369,
    height: 0.725954,
    fill: "#111111"
  })), _rect105 || (_rect105 = /*#__PURE__*/React.createElement("rect", {
    x: 46.8535,
    y: 34.7129,
    width: 0.742369,
    height: 0.725954,
    fill: "#111111"
  })), _rect106 || (_rect106 = /*#__PURE__*/React.createElement("rect", {
    x: 47.9648,
    y: 34.7119,
    width: 0.742369,
    height: 0.725954,
    fill: "#111111"
  })), _rect107 || (_rect107 = /*#__PURE__*/React.createElement("rect", {
    x: 46.8535,
    y: 35.7402,
    width: 0.742369,
    height: 0.725954,
    fill: "#111111"
  })), _rect108 || (_rect108 = /*#__PURE__*/React.createElement("rect", {
    x: 47.9648,
    y: 35.7402,
    width: 0.742369,
    height: 0.725954,
    fill: "#111111"
  })), _rect109 || (_rect109 = /*#__PURE__*/React.createElement("rect", {
    x: 46.8535,
    y: 36.7695,
    width: 0.742369,
    height: 0.725954,
    fill: "#111111"
  })), _rect110 || (_rect110 = /*#__PURE__*/React.createElement("rect", {
    x: 47.9648,
    y: 36.7705,
    width: 0.742369,
    height: 0.725954,
    fill: "#111111"
  })), _rect111 || (_rect111 = /*#__PURE__*/React.createElement("rect", {
    x: 43.5176,
    y: 30.5977,
    width: 0.742369,
    height: 0.725954,
    fill: "#111111"
  })), _rect112 || (_rect112 = /*#__PURE__*/React.createElement("rect", {
    x: 43.5176,
    y: 31.6279,
    width: 0.742369,
    height: 0.725954,
    fill: "#111111"
  })), _rect113 || (_rect113 = /*#__PURE__*/React.createElement("rect", {
    x: 43.5176,
    y: 28.4814,
    width: 0.742369,
    height: 0.725954,
    fill: "#111111"
  })), _rect114 || (_rect114 = /*#__PURE__*/React.createElement("rect", {
    x: 43.5176,
    y: 27.4512,
    width: 0.742369,
    height: 0.725954,
    fill: "#111111"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8962 26.8351L44.2599 26.4648V27.1908H43.5176L43.8962 26.8351Z",
    fill: "#111111"
  })), _rect115 || (_rect115 = /*#__PURE__*/React.createElement("rect", {
    x: 43.5176,
    y: 32.6553,
    width: 0.742369,
    height: 0.725954,
    fill: "#111111"
  })), _rect116 || (_rect116 = /*#__PURE__*/React.createElement("rect", {
    x: 43.5176,
    y: 29.5098,
    width: 0.742369,
    height: 0.725954,
    fill: "#111111"
  })), _rect117 || (_rect117 = /*#__PURE__*/React.createElement("rect", {
    x: 43.5176,
    y: 33.6826,
    width: 0.742369,
    height: 0.725954,
    fill: "#111111"
  })), _rect118 || (_rect118 = /*#__PURE__*/React.createElement("rect", {
    x: 43.5176,
    y: 34.7139,
    width: 0.742369,
    height: 0.725954,
    fill: "#111111"
  })), _rect119 || (_rect119 = /*#__PURE__*/React.createElement("rect", {
    x: 43.5176,
    y: 35.7393,
    width: 0.742369,
    height: 0.725954,
    fill: "#111111"
  })), _rect120 || (_rect120 = /*#__PURE__*/React.createElement("rect", {
    x: 43.5176,
    y: 36.7676,
    width: 0.742369,
    height: 0.725954,
    fill: "#111111"
  })), _rect121 || (_rect121 = /*#__PURE__*/React.createElement("rect", {
    x: 25.623,
    y: 30.4082,
    width: 0.757217,
    height: 0.740473,
    fill: "#111111"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7539 30.5303L27.1325 30.8388L27.5111 31.1473H26.7539V30.5303Z",
    fill: "#111111"
  })), _rect122 || (_rect122 = /*#__PURE__*/React.createElement("rect", {
    x: 25.623,
    y: 31.459,
    width: 0.757217,
    height: 0.740473,
    fill: "#111111"
  })), _rect123 || (_rect123 = /*#__PURE__*/React.createElement("rect", {
    x: 26.7539,
    y: 31.459,
    width: 0.757217,
    height: 0.740473,
    fill: "#111111"
  })), _rect124 || (_rect124 = /*#__PURE__*/React.createElement("rect", {
    x: 25.623,
    y: 32.5068,
    width: 0.757217,
    height: 0.740473,
    fill: "#111111"
  })), _rect125 || (_rect125 = /*#__PURE__*/React.createElement("rect", {
    x: 26.7539,
    y: 32.5068,
    width: 0.757217,
    height: 0.740473,
    fill: "#111111"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8945 32.5068L28.2731 32.8771L28.6517 33.2473H27.8945V32.5068Z",
    fill: "#111111"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9199 32.5068L30.5413 32.8771L30.1627 33.2473H30.9199V32.5068Z",
    fill: "#111111"
  })), _rect126 || (_rect126 = /*#__PURE__*/React.createElement("rect", {
    x: 25.623,
    y: 33.5537,
    width: 0.757217,
    height: 0.740473,
    fill: "#111111"
  })), _rect127 || (_rect127 = /*#__PURE__*/React.createElement("rect", {
    x: 26.7539,
    y: 33.5576,
    width: 0.757217,
    height: 0.740473,
    fill: "#111111"
  })), _rect128 || (_rect128 = /*#__PURE__*/React.createElement("rect", {
    x: 27.8945,
    y: 33.5576,
    width: 0.757217,
    height: 0.740473,
    fill: "#111111"
  })), _rect129 || (_rect129 = /*#__PURE__*/React.createElement("rect", {
    width: 0.757217,
    height: 0.740473,
    transform: "matrix(-1 0 0 1 30.9199 33.5566)",
    fill: "#111111"
  })), _rect130 || (_rect130 = /*#__PURE__*/React.createElement("rect", {
    x: 29.0273,
    y: 33.5566,
    width: 0.757217,
    height: 0.740473,
    fill: "#111111"
  })), _rect131 || (_rect131 = /*#__PURE__*/React.createElement("rect", {
    x: 25.623,
    y: 34.6035,
    width: 0.757217,
    height: 0.740473,
    fill: "#111111"
  })), _rect132 || (_rect132 = /*#__PURE__*/React.createElement("rect", {
    x: 26.7539,
    y: 34.6035,
    width: 0.757217,
    height: 0.740473,
    fill: "#111111"
  })), _rect133 || (_rect133 = /*#__PURE__*/React.createElement("rect", {
    x: 27.8945,
    y: 34.6035,
    width: 0.757217,
    height: 0.740473,
    fill: "#111111"
  })), _rect134 || (_rect134 = /*#__PURE__*/React.createElement("rect", {
    width: 0.757217,
    height: 0.740473,
    transform: "matrix(-1 0 0 1 30.9199 34.6035)",
    fill: "#111111"
  })), _rect135 || (_rect135 = /*#__PURE__*/React.createElement("rect", {
    x: 29.0273,
    y: 34.6035,
    width: 0.757217,
    height: 0.740473,
    fill: "#111111"
  })), _rect136 || (_rect136 = /*#__PURE__*/React.createElement("rect", {
    x: 25.623,
    y: 35.6533,
    width: 0.757217,
    height: 0.740473,
    fill: "#111111"
  })), _rect137 || (_rect137 = /*#__PURE__*/React.createElement("rect", {
    x: 26.7539,
    y: 35.6543,
    width: 0.757217,
    height: 0.740473,
    fill: "#111111"
  })), _rect138 || (_rect138 = /*#__PURE__*/React.createElement("rect", {
    x: 27.8945,
    y: 35.6543,
    width: 0.757217,
    height: 0.740473,
    fill: "#111111"
  })), _rect139 || (_rect139 = /*#__PURE__*/React.createElement("rect", {
    width: 0.757217,
    height: 0.740473,
    transform: "matrix(-1 0 0 1 30.9199 35.6543)",
    fill: "#111111"
  })), _rect140 || (_rect140 = /*#__PURE__*/React.createElement("rect", {
    x: 29.0273,
    y: 35.6533,
    width: 0.757217,
    height: 0.740473,
    fill: "#111111"
  })), _rect141 || (_rect141 = /*#__PURE__*/React.createElement("rect", {
    x: 25.623,
    y: 36.7041,
    width: 0.757217,
    height: 0.740473,
    fill: "#111111"
  })), _rect142 || (_rect142 = /*#__PURE__*/React.createElement("rect", {
    x: 26.7539,
    y: 36.7031,
    width: 0.757217,
    height: 0.740473,
    fill: "#111111"
  })), _rect143 || (_rect143 = /*#__PURE__*/React.createElement("rect", {
    width: 0.757217,
    height: 0.740473,
    transform: "matrix(-1 0 0 1 32.0605 31.459)",
    fill: "#111111"
  })), _rect144 || (_rect144 = /*#__PURE__*/React.createElement("rect", {
    width: 0.757217,
    height: 0.740473,
    transform: "matrix(-1 0 0 1 32.0605 30.4082)",
    fill: "#111111"
  })), _rect145 || (_rect145 = /*#__PURE__*/React.createElement("rect", {
    width: 0.757217,
    height: 0.740473,
    transform: "matrix(-1 0 0 1 32.0605 32.5068)",
    fill: "#111111"
  })), _rect146 || (_rect146 = /*#__PURE__*/React.createElement("rect", {
    width: 0.757217,
    height: 0.740473,
    transform: "matrix(-1 0 0 1 32.0605 33.5576)",
    fill: "#111111"
  })), _rect147 || (_rect147 = /*#__PURE__*/React.createElement("rect", {
    width: 0.757217,
    height: 0.740473,
    transform: "matrix(-1 0 0 1 32.0605 34.6035)",
    fill: "#111111"
  })), _rect148 || (_rect148 = /*#__PURE__*/React.createElement("rect", {
    width: 0.757217,
    height: 0.740473,
    transform: "matrix(-1 0 0 1 32.0605 35.6543)",
    fill: "#111111"
  })), _rect149 || (_rect149 = /*#__PURE__*/React.createElement("rect", {
    width: 0.757217,
    height: 0.740473,
    transform: "matrix(-1 0 0 1 32.0605 36.7031)",
    fill: "#111111"
  })), _rect150 || (_rect150 = /*#__PURE__*/React.createElement("rect", {
    x: 27.8945,
    y: 36.7031,
    width: 0.757217,
    height: 0.740473,
    fill: "#111111"
  })), _rect151 || (_rect151 = /*#__PURE__*/React.createElement("rect", {
    width: 0.757217,
    height: 0.740473,
    transform: "matrix(-1 0 0 1 30.9199 36.7031)",
    fill: "#111111"
  })), _rect152 || (_rect152 = /*#__PURE__*/React.createElement("rect", {
    x: 29.0273,
    y: 36.7031,
    width: 0.757217,
    height: 0.740473,
    fill: "#111111"
  })), _rect153 || (_rect153 = /*#__PURE__*/React.createElement("rect", {
    x: 17.2988,
    y: 30.4082,
    width: 0.742369,
    height: 0.740473,
    fill: "#111111"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4102 30.5303L18.7813 30.8388L19.1525 31.1473H18.4102V30.5303Z",
    fill: "#111111"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9522 33.9279L20.2714 33.5576V34.2981H19.6367L19.9522 33.9279Z",
    fill: "#111111"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9473 32.5078H20.3271V33.2483H19.9473V32.5078Z",
    fill: "#111111"
  })), _rect154 || (_rect154 = /*#__PURE__*/React.createElement("rect", {
    width: 0.742369,
    height: 0.740473,
    transform: "matrix(-1 0 0 1 22.4961 33.5557)",
    fill: "#111111"
  })), _rect155 || (_rect155 = /*#__PURE__*/React.createElement("rect", {
    width: 0.742369,
    height: 0.740473,
    transform: "matrix(-1 0 0 1 22.4961 32.5078)",
    fill: "#111111"
  })), _rect156 || (_rect156 = /*#__PURE__*/React.createElement("rect", {
    width: 0.742369,
    height: 0.740473,
    transform: "matrix(-1 0 0 1 22.4961 31.5176)",
    fill: "#111111"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4961 30.5137L21.7537 30.5137V31.1483H22.4961V30.5137Z",
    fill: "#111111"
  })), _rect157 || (_rect157 = /*#__PURE__*/React.createElement("rect", {
    x: 20.6348,
    y: 33.5576,
    width: 0.742369,
    height: 0.740473,
    fill: "#111111"
  })), _rect158 || (_rect158 = /*#__PURE__*/React.createElement("rect", {
    x: 20.6348,
    y: 32.5078,
    width: 0.742369,
    height: 0.740473,
    fill: "#111111"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6348 31.5176L21.3771 31.5176V32.2581H20.6348L20.6348 31.5176Z",
    fill: "#111111"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4102 35.0966L19.1525 34.7881V35.3434H18.4102V35.0966Z",
    fill: "#111111"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M18.043 35.0986L17.3006 34.79V35.3454H18.043V35.0986Z",
    fill: "#111111"
  })), _rect159 || (_rect159 = /*#__PURE__*/React.createElement("rect", {
    x: 19.5234,
    y: 34.6035,
    width: 0.742369,
    height: 0.740473,
    fill: "#111111"
  })), _rect160 || (_rect160 = /*#__PURE__*/React.createElement("rect", {
    width: 0.742369,
    height: 0.740473,
    transform: "matrix(-1 0 0 1 22.4961 34.6035)",
    fill: "#111111"
  })), _rect161 || (_rect161 = /*#__PURE__*/React.createElement("rect", {
    x: 20.6348,
    y: 34.6035,
    width: 0.742369,
    height: 0.740473,
    fill: "#111111"
  })), _rect162 || (_rect162 = /*#__PURE__*/React.createElement("rect", {
    x: 17.2988,
    y: 35.6533,
    width: 0.742369,
    height: 0.740473,
    fill: "#111111"
  })), _rect163 || (_rect163 = /*#__PURE__*/React.createElement("rect", {
    x: 18.4102,
    y: 35.6533,
    width: 0.742369,
    height: 0.740473,
    fill: "#111111"
  })), _rect164 || (_rect164 = /*#__PURE__*/React.createElement("rect", {
    x: 19.5234,
    y: 35.6533,
    width: 0.742369,
    height: 0.740473,
    fill: "#111111"
  })), _rect165 || (_rect165 = /*#__PURE__*/React.createElement("rect", {
    width: 0.742369,
    height: 0.740473,
    transform: "matrix(-1 0 0 1 22.4961 35.6533)",
    fill: "#111111"
  })), _rect166 || (_rect166 = /*#__PURE__*/React.createElement("rect", {
    x: 20.6348,
    y: 35.6543,
    width: 0.742369,
    height: 0.740473,
    fill: "#111111"
  })), _rect167 || (_rect167 = /*#__PURE__*/React.createElement("rect", {
    x: 17.2988,
    y: 36.7041,
    width: 0.742369,
    height: 0.740473,
    fill: "#111111"
  })), _rect168 || (_rect168 = /*#__PURE__*/React.createElement("rect", {
    x: 18.4102,
    y: 36.7031,
    width: 0.742369,
    height: 0.740473,
    fill: "#111111"
  })), _rect169 || (_rect169 = /*#__PURE__*/React.createElement("rect", {
    width: 0.742369,
    height: 0.740473,
    transform: "matrix(-1 0 0 1 23.6113 31.459)",
    fill: "#111111"
  })), _rect170 || (_rect170 = /*#__PURE__*/React.createElement("rect", {
    width: 0.742369,
    height: 0.740473,
    transform: "matrix(-1 0 0 1 23.6113 30.4082)",
    fill: "#111111"
  })), _rect171 || (_rect171 = /*#__PURE__*/React.createElement("rect", {
    width: 0.742369,
    height: 0.740473,
    transform: "matrix(-1 0 0 1 23.6113 32.5078)",
    fill: "#111111"
  })), _rect172 || (_rect172 = /*#__PURE__*/React.createElement("rect", {
    width: 0.742369,
    height: 0.740473,
    transform: "matrix(-1 0 0 1 23.6113 33.5557)",
    fill: "#111111"
  })), _rect173 || (_rect173 = /*#__PURE__*/React.createElement("rect", {
    width: 0.742369,
    height: 0.740473,
    transform: "matrix(-1 0 0 1 23.6113 34.6035)",
    fill: "#111111"
  })), _rect174 || (_rect174 = /*#__PURE__*/React.createElement("rect", {
    width: 0.742369,
    height: 0.740473,
    transform: "matrix(-1 0 0 1 23.6113 35.6533)",
    fill: "#111111"
  })), _rect175 || (_rect175 = /*#__PURE__*/React.createElement("rect", {
    width: 0.742369,
    height: 0.740473,
    transform: "matrix(-1 0 0 1 23.6113 36.7041)",
    fill: "#111111"
  })), _rect176 || (_rect176 = /*#__PURE__*/React.createElement("rect", {
    x: 19.5234,
    y: 36.7031,
    width: 0.742369,
    height: 0.740473,
    fill: "#111111"
  })), _rect177 || (_rect177 = /*#__PURE__*/React.createElement("rect", {
    width: 0.742369,
    height: 0.740473,
    transform: "matrix(-1 0 0 1 22.4961 36.7041)",
    fill: "#111111"
  })), _rect178 || (_rect178 = /*#__PURE__*/React.createElement("rect", {
    x: 20.6348,
    y: 36.7031,
    width: 0.742369,
    height: 0.740473,
    fill: "#111111"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1732 31.7011C18.5081 31.7011 18.819 31.7998 19.0782 31.9688C20.1083 31.004 21.1386 30.0394 22.1692 29.075C22.0197 28.8338 21.9339 28.5513 21.9339 28.249C21.9339 27.3662 22.6655 26.6507 23.568 26.6507C24.4712 26.6507 25.2028 27.3662 25.2028 28.249C25.2028 28.4119 25.1775 28.5692 25.1315 28.7172C26.1398 29.2794 27.1482 29.8414 28.1569 30.4032C28.4558 30.0824 28.886 29.8813 29.3646 29.8813C29.7052 29.8813 30.0212 29.9831 30.2829 30.1577C31.5952 28.9531 32.9074 27.7485 34.2197 26.5439C34.0752 26.3058 33.9926 26.0282 33.9926 25.7315C33.9926 24.8487 34.7242 24.1331 35.6267 24.1331C36.5299 24.1331 37.2614 24.8487 37.2614 25.7315C37.261 25.8787 37.2415 26.0202 37.2028 26.1559C38.0307 26.6169 38.8583 27.0782 39.6858 27.5396C39.9847 27.2188 40.4149 27.0177 40.8935 27.0177C41.2341 27.0177 41.5501 27.1195 41.8118 27.2934C43.1241 26.0893 44.4363 24.8849 45.7486 23.6803C45.6041 23.4422 45.5215 23.1646 45.5215 22.8679C45.5215 21.9851 46.2531 21.2695 47.1556 21.2695C48.0587 21.2695 48.7903 21.9851 48.7903 22.8679C48.7903 23.7507 48.0587 24.4662 47.1556 24.4662C46.8157 24.4662 46.4997 24.3645 46.238 24.1905C44.9257 25.3951 43.6135 26.5994 42.3012 27.8036C42.445 28.0417 42.5283 28.3193 42.5283 28.6161C42.5283 29.4988 41.7961 30.2144 40.8935 30.2144C39.991 30.2144 39.2594 29.4988 39.2594 28.6161C39.2594 28.4532 39.2847 28.2953 39.3307 28.1472C38.5091 27.6895 37.6876 27.2316 36.866 26.7734C36.5664 27.1145 36.1224 27.3298 35.6267 27.3298C35.2868 27.3298 34.9708 27.2281 34.7091 27.0541C33.3968 28.2587 32.0846 29.4632 30.7723 30.6678C30.9168 30.9053 30.9994 31.1829 30.9994 31.4796C30.9994 32.3624 30.2672 33.0786 29.3646 33.0786C28.4621 33.0786 27.7305 32.3624 27.7305 31.4796C27.7305 31.3168 27.7558 31.1595 27.8018 31.0108C26.7936 30.449 25.7853 29.8871 24.7771 29.3249C24.4781 29.6463 24.0474 29.8474 23.568 29.8474C23.2338 29.8474 22.9228 29.7493 22.6636 29.5803L19.5727 32.4741C19.7215 32.7153 19.8073 32.9978 19.8073 33.3001C19.8073 34.1829 19.0757 34.8984 18.1732 34.8984C17.2707 34.8984 16.5391 34.1829 16.5391 33.3001C16.5391 32.4173 17.2707 31.7011 18.1732 31.7011ZM40.8935 27.6445C40.3449 27.6445 39.9002 28.0794 39.9002 28.6161C39.9002 29.1527 40.3449 29.5877 40.8935 29.5877C41.4422 29.5877 41.8869 29.1527 41.8869 28.6161C41.8869 28.0794 41.4422 27.6445 40.8935 27.6445ZM47.1556 21.8963C46.6075 21.8963 46.1623 22.3312 46.1623 22.8679C46.1623 23.4046 46.6075 23.8395 47.1556 23.8395C47.7043 23.8395 48.1496 23.4046 48.1496 22.8679C48.1496 22.3312 47.7043 21.8963 47.1556 21.8963ZM23.568 27.2774C23.02 27.2774 22.5747 27.7123 22.5747 28.249C22.5747 28.7857 23.02 29.2206 23.568 29.2206C24.1167 29.2206 24.5614 28.7857 24.5614 28.249C24.5614 27.7123 24.1167 27.2774 23.568 27.2774ZM29.3646 30.5081C28.8166 30.5081 28.3713 30.943 28.3713 31.4796C28.3713 32.0163 28.8166 32.4513 29.3646 32.4513C29.9133 32.4513 30.358 32.0163 30.358 31.4796C30.358 30.943 29.9133 30.5081 29.3646 30.5081ZM35.6267 24.7599C35.0786 24.7599 34.6334 25.1948 34.6334 25.7315C34.6334 26.2682 35.0786 26.7031 35.6267 26.7031C36.1754 26.7031 36.6207 26.2682 36.6207 25.7315C36.6207 25.1948 36.1754 24.7599 35.6267 24.7599ZM18.1732 32.3285C17.6245 32.3285 17.1798 32.7634 17.1798 33.3001C17.1798 33.8368 17.6245 34.2717 18.1732 34.2717C18.7219 34.2717 19.1665 33.8368 19.1665 33.3001C19.1665 32.7634 18.7219 32.3285 18.1732 32.3285Z",
    fill: "#2B8DC8"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5836 26.309V18.9199C23.5836 18.4023 23.1582 17.9785 22.6379 17.9785H18.2191C17.6988 17.9785 17.2734 18.4023 17.2734 18.9199V31.5698C17.5401 31.4335 17.8433 31.3564 18.1639 31.3564C18.4547 31.3564 18.74 31.4205 18.9998 31.5433L21.6693 29.0011C21.5689 28.7636 21.5168 28.5076 21.5168 28.2472C21.5168 27.1751 22.3905 26.3053 23.4682 26.3053C23.5071 26.3053 23.5455 26.3065 23.5836 26.309Z",
    fill: "#2B8DC8"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6328 28.6029L28.0603 29.9792C28.4075 29.6954 28.8434 29.5381 29.2991 29.5381C29.5967 29.5381 29.8875 29.6048 30.1523 29.7331L31.9429 28.0613V12.6416C31.9429 12.124 31.517 11.7002 30.9968 11.7002H26.579C26.0588 11.7002 25.6328 12.124 25.6328 12.6416V28.6029Z",
    fill: "#2B8DC8"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1348 8.15133V24.6136C34.4876 24.1152 35.0711 23.7895 35.7303 23.7895C36.8086 23.7895 37.6824 24.6593 37.6824 25.7314C37.6824 25.8149 37.6772 25.8978 37.6669 25.98L39.6698 27.1157C39.8967 26.93 40.1615 26.7986 40.4449 26.7295V8.15133C40.4449 7.63376 40.0195 7.20996 39.4992 7.20996H35.0804C34.5602 7.20996 34.1348 7.63376 34.1348 8.15133Z",
    fill: "#2B8DC8"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M42.377 26.3071L45.2738 23.6027C45.1783 23.3695 45.1287 23.1203 45.1287 22.8661C45.1287 21.794 46.0023 20.9242 47.0799 20.9242C47.7465 20.9242 48.3349 21.2567 48.6871 21.7637V18.9199C48.6871 18.4023 48.2611 17.9785 47.7409 17.9785H43.3231C42.8029 17.9785 42.377 18.4023 42.377 18.9199V26.3071Z",
    fill: "#2B8DC8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQDlogo);
export default __webpack_public_path__ + "static/media/QDlogo.327f532407f340f52757b9213cc8cdb5.svg";
export { ForwardRef as ReactComponent };